// extracted by mini-css-extract-plugin
export default {"PropertySpyResultItem__Root":"PropertySpyResultItem_PropertySpyResultItem__Root__osV9K"};